<div class="page-container gap-24">
  <div class="page-title justify-space-between">
    <span class="font-bold-display-medium"> Gutscheine </span>
  </div>
  <app-tab-menu
    class="max-width-800"
    [tabs]="tabs"
    [activeTab]="activeTab"
    (tabChange)="onTabChange($event)"></app-tab-menu>
  @if (activeTab === 'promo-codes') {
    <app-promo-codes class="align-self-stretch"></app-promo-codes>
  } @else if (activeTab === 'sellable-codes') {
    <app-sellable-codes class="align-self-stretch"></app-sellable-codes>
  } @else if (activeTab === 'coupon-usage') {
    <app-coupon-usage-log
      class="align-self-stretch padding-bottom-48"></app-coupon-usage-log>
  }
</div>
